<template>
  <div class="search-container">
    <label
      id="searchs"
      ref="search"
      :for="this.labelKey"
      >
      <span
        style="
          color: red;
          font-weight: 500;
          color: #cf1322;
          pointer-events: none;
        "
        >* </span
      >Search Locations  </label
    >
    
    <el-autocomplete
      ref="searchAutocomplete"
      class="search-autocomplete connected"
      :id="this.labelKey"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="true"
      :popper-append-to-body="false"
      :hide-loading="true"
      @select="handleSelect"
      @blur="handleBlur($event)"
      @focus="handFocus($event)"
      @input="watchData($event)"
      v-bind="$attrs"
      v-on="$listeners"
      popper-class="search-autocomplete-popper"
    >
       <template  slot-scope="{ item }"> 
        <!-- searchLoading -->
        <div v-show="searchLoading === false">
          <div v-if="item.address == 'No Matches'" class="search-disbled">
            <button :disabled='true'>No Matches</button>
          </div>
          <div v-else class="search-result-wrapper">
            <div class="search-result-container">
              <span
                v-if="item.pointType=== 'address' && item.address !== 'No Matches'"
                class="address-icon search-result-icon"
              ></span>
              <svg-icon v-else-if="item.address !== 'No Matches'" :name="getIconUrl(item)" class="poi-icon" />
              <div class="search-result-content">
                <p
                  v-if="item.isHistory || item.pointType === 'poi'"
                  class="title overflow-management"
                >
                  {{ item.unifiedTitle }}
                </p>
                <p
                  v-else
                  v-html="item.unifiedTitle"
                  class="title overflow-management"
                ></p>
                <p class="address overflow-management" aria-disabled="true">
                  {{ item.address }}
                </p>
              </div>
            </div>
          </div>
        </div>
    </template>
     
    </el-autocomplete>
    <div class="search-loading" v-if="searchLoading">
      <div class="loading"></div>
      <span>Searching...</span>
    </div>
    <span class="places" v-if="isShowClearIcon"><svg-icon  name="icon-16-place (1)" ></svg-icon></span>
    <span class="places clearIcon" v-else @mousedown="clearSearchLocation"><svg-icon  name="input-close" ></svg-icon></span>
  </div>
</template>


<script>
import { mapActions } from "vuex";
import { getSearchTimeZone } from "@/api/common";
import { iconInDifferentPoint } from "@/config/map-icons";
import { combiningStrings } from '@/tools/basic-methods'
import { getPointAutosuggest } from '@/api/search'
export default {
  props: ["token","currentValue","SoptIndex","labelKey",'type', 'searchLoaction'],
  data() {
    return {
      pickupAddress: "",
      currentInfo: null,
      list: [],
      isRequestApi: false,
      isShowClearIcon: true,
      searchLoading: false,
      isRemover: false,
      selectValue: '',
      isSelect: false,
      pickCity: '',
      dropCity: ''
    };
  },
  watch: {
    searchLoaction: {
      handler(value) {
        if(value.pickupCity) {
          this.searchAddressApi(value.pickupCity).then(( res ) => {
            this.pickCity = res.value
            this.updateSearchInfo(res, 'up')
          })
        }
        if(value.deliveryCity) {
          this.searchAddressApi(value.deliveryCity).then(( res ) => {
            this.dropCity = res.value
            this.updateSearchInfo(res, 'Drop')
          })
        }
      },
     },
    currentValue:{
      handler(value) {
        this.isRemover = true
        let { type, driverId, address} = this.$route.query
        try {
          if (!value) {
            this.$nextTick(() => {
              this.$refs["search"].classList.add("search-blur");
              this.$refs["search"].classList.remove("search-focus");
            })
          } else {
            this.$nextTick(() => {
              this.$refs["search"].classList.remove("search-blur");
              this.$refs["search"].classList.add("search-value-focus");
            })
          }
        } catch (error) {
          console.log(error);
        }
        if(type == 'tp') {
          if(!this.currentInfo) {
            let data = JSON.parse(localStorage.getItem('tpLoad'));
            if(data.pickupCity) {
              this.searchAddressApi(data.pickupCity).then(( res ) => {
                this.pickCity = res.value
                this.updateSearchInfo(res, 'up')
              })
            }
            if(data.deliveryCity) {
                this.searchAddressApi(data.deliveryCity).then(( res ) => {
                  this.dropCity = res.value
                  this.updateSearchInfo(res, 'Drop')
                })
            }  
          }
          
        }
        if(driverId) {
          if(!this.currentInfo) {
            if(address) {
                this.searchAddressApi(address).then(( res ) => {
                  this.pickCity = res.value
                  this.updateSearchInfo(res, 'up')
                })
            } 
           }
        }
      },
      immediate: true,
      deep: true
    },
    currentInfo: {
      // handler(value) {
      //   try {
      //   let dom = this.$refs["search"].nextElementSibling.nextElementSibling.children[0].children[0];
        
      //     dom.addEventListener('blur',() => {
      //       if(value) {
      //         this.$refs["search"].classList.add("search-value-focus");
      //       }
      //     })
      //     if(value) {
      //       if(value.value !== dom.value) {
      //         dom.value = value.value
      //         this.$refs["search"].classList.add("search-value-focus");
      //       }else if(value === this.currentInfo.value) {
      //         dom.value = value.value
      //       }
      //     }
      //   } catch  {
      //     return
      //   }
      // },
      // deep: true
    }
  },
  created() {},
  methods: {
    ...mapActions({
      querySearchAsync: "dispatchSearch/querySearch",
      updateDispatchSearchValueAsync: "dispatchSearch/updateDispatchSearchValue",
      setSearchResultAsync: "dispatchSearch/setSearchResult",
      refreshData: "dispatch/refreshData",
      addSearchReturnAsync: 'search/addSearchReturn'
    }),
    searchAddressApi(value) {
      let data = { input: value, lat: '41.6179', lon: '-90.7815', triggerAction: 'Input' }
      let params = { source: 'loads' }
      return new Promise(( resolve ) => {
        getPointAutosuggest(params, data).then((res) => {
            let data = {...res.data[0], ...{latitude: res.data[0].location.lat, longitude: res.data[0].location.lon, value: res.data[0].title}}
            console.log(data,'207');
            resolve(data)
        })
      })
    },
    handFocus() {
      this.isShowClearIcon = false
      this.activeDom()
    },
    handleBlur(el) {
      this.isShowClearIcon = true
      setTimeout(() => {
        let value = this.$refs['searchAutocomplete'].$el.children[0].children[0].value
        try {
          if(this.isRemover === false) {
            this.clearSearchLocation()
          }else {
            if(value !== this.currentInfo.value) {
              value = this.currentInfo.value
              this.$emit('resetCityName', {token: this.token, StopIndex: this.SoptIndex, value: this.currentInfo.value})
            }
          }
        } catch  {
          return
        }
        
      })
      if (el.target.value) {
        this.focusDom()
        this.$emit('isHasSearchInfo', {data: this.list[0]?.address === 'No Matches' ? true : false, token: this.token})
      } else {
        this.blurDom()
      }
    },
    clearSearchLocation() {
      setTimeout(() => {
        this.$refs['searchAutocomplete'].$el.children[0].children[0].value = ''
        this.blurDom()
      })
      this.$emit('clear', {token: this.token, StopIndex: this.SoptIndex, clear: true})
    },
    watchData(el) {
      if (el) {
        this.focusDom()
      } else {
        this.blurDom()
      }
    },
    blurDom() {
        this.$refs["search"].classList.add("search-blur");
        this.$refs["search"].classList.remove("search-focus");
        this.$refs["search"].nextElementSibling.classList.remove("is-focus");
    },
    focusDom() {
        this.$refs["search"].classList.remove("search-blur");
        this.$refs["search"].classList.add("search-value-focus");
        this.$refs["search"].nextElementSibling.classList.remove("is-focus");
        // 
    },
    activeDom() {
        this.$refs["search"].classList.remove("search-blur");
        this.$refs["search"].classList.remove("search-value-focus");
        this.$refs["search"].classList.add("search-focus");
        this.$refs["search"].nextElementSibling.classList.add("is-focus");
    },
    // 失去焦点时更新数据
    handleSearch() {
      this.searchValue = this.pickupAddress;
      this.$refs.searchAutocomplete.focus();
    },
    getIconUrl(point) {
      return iconInDifferentPoint(point).listIcon;
    },
    querySearch(queryString, cb) {
      queryString = this.$refs['searchAutocomplete'].$el.children[0].children[0].value

      if (this.selectValue && this.list.length && queryString === this.selectValue) {
        cb(this.list)
        return null
      }
      this.selectValue = ''
      if (this.list.length === 0 || this.list[0].value === 'No Matches') {
        this.searchLoading = true
      }
      this.isSelect = false
      this.querySearchAsync({
        value: queryString,
        searchValue: this.searchValue,
        isShowHistoricalData: true,
      }).then((res) => {
        // When no search results are returned, selecting data or clearing the search does not display results
        if (this.isSelect || !this.$refs['searchAutocomplete'].$el.children[0].children[0].value) {
          cb([])
          this.searchLoading = false
          return null
        }
        if (this.$refs['searchAutocomplete'].$el.children[0].children[0].value !== queryString) return null
        this.searchLoading = false
        this.searchValue = "";
        // 有历史记录时展示清除按钮
        // if (!queryString && res.length) {
        //   res.unshift({ showClearHistory: true, value: "Noda" });
        // }
       
        if(res.length === 0) {
          res = [{ address: 'No Matches', value: "No Matches" }]
          this.list = res
        }
        this.list = res
        cb(res);
      }).catch(( error ) => {
        if(error) {
          this.searchLoading = false
        }
      })
    },
    handleSelect(item) {
      let info = Object.assign({}, item, {
        unifiedTitle: item.value,
        isMapChange: true,
      });
      this.selectValue = item.value
      this.isSelect = true
      this.updateSearchInfo(info);
      this.addSearchReturnAsync(item)
      // To close the popup when no search results are returned
      this.$refs.searchAutocomplete.close();
      this.$refs.searchAutocomplete.suggestions = [];
    },
    clearHistory() {
      localStorage.removeItem("addressSearchList");
      this.$refs.searchAutocomplete.close();
      this.$refs.searchAutocomplete.suggestions = [];
    },
    handleEmpty() {
      this.CurrentIndex = this.pickupAddress = undefined;
      this.$refs.searchAutocomplete.close();
      this.$refs.searchAutocomplete.suggestions = [];
    },
    updateSearchInfo(info, type) {
      this.currentInfo = info
      this.isRemover = true
      let currentValue = this.pickupAddress;
      this.updateDispatchSearchValueAsync(currentValue);
      this.setSearchResultAsync({ result: info, source: "dispatch" });
      let showaddress = ''
      let appaddress = ''
      let cityInfo = {
        city: info.city || '',
        state: info.state || '',
        postalCode: info.zipCode || '',
        country: info.country || '',
      }
      if (info.pointType === 'poi') {
        let s = info.address.indexOf(',') !== -1 ? info.address.slice(0, info.address.indexOf(',')) : info.address
        let a = combiningStrings([s, cityInfo.city, cityInfo.state])
        showaddress = a
        appaddress = a
      } else {
        showaddress = info.value
        appaddress = info.value === info.city ? combiningStrings([info.value, info.state]) : combiningStrings([info.value, info.city, info.state])
      }

      getSearchTimeZone(info.latitude, info.longitude).then((res) => {
        let dataInfo = {
          cityData: Object.assign(
            {},
            cityInfo,
            { 
              latitude: info.latitude,
              longitude: info.longitude,
              address: appaddress,
              showaddress: showaddress,
              Tz: res.timeZone.name,
              street: info.street,
            },
            { souch: info }
          ),
          pickCity: this.pickCity,
          dropCity: this.dropCity,
          token: type ? type : this.token,
          StopIndex: this.SoptIndex
        }
        console.log(dataInfo,'397');
        this.$emit("getLoaction", dataInfo)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.search-loading {
  display: flex;
  height: 52px;
  width: 100%;
  align-items: center;
  border-radius: 6px;
  position: absolute;
  z-index: 99999;
  padding-left: 18px;
  box-shadow: 0 1px 5px 0 rgba(0, 5, 57, 0.2);
  border: solid 1px #e1e3e9;
  background: #fff;
  .loading {
    width: 16px;
    height: 16px;
    line-height: 16px;
    margin-right: 8px;
    animation: Rotation .5s linear infinite;
    background-image: url('../../../image/Loading-Blue.svg');
    @keyframes identifier {
      0% {
        transform: translate3d(0%);
      }
      100% {
        transform: translate3d(100%);
      }
    }
  }
  span {
    color: #000;
    font-size: 12px;
    font-weight: 500;
  }
}

.places {
  position: absolute;
  z-index: 999;
  right: 10px;
  top: 10px;
}
.clearIcon {
  cursor: pointer;
  color: #b2b6c0;
  &:hover {
    color: #000;
  }
}
/deep/ .el-input__inner {
  height: 36px;
  border: 1px solid #b4bac8;
  color: #000c2e;
  font-family: OpenSans;
  padding: 4px 12px 0 ;
  font-size: 12px;
  font-weight: 600;
  &:hover {
    border: 1px solid #8993a9;
  }
  &:focus {
      border: 1px solid #4066d4 !important;
      box-shadow: 0 0 0 2px #c6d1f2;
      outline: 0;
  }
}
// .is-focus::after{
//   content: '';
//   position: absolute;
//   top: -2px;
//   left: -2px;
//   width: 100%;
//   height: 36px;
//   border: 2px solid #c6d1f2;
//   border-radius: 6px;
// }
.searchFont {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 99;
}
.search-disbled {
  border: none;
  button {
    width: 100%;
    height: 36px;
    border: 0;
    border: none;
    outline: 0;
    text-align: left;
    background: #fff;
    padding-left: 15px;
  }
  
}
.search-container {
  position: relative;
  label {
    z-index: 1200;
    position: absolute;
    font-size: 12px;
    color: #7f8596;
    top: -10px;
    margin-left: 15px;
    transform: translateY(20px);
    transition: all 200ms ease;
    font-weight: 500;
  }
  input {
    width: 100%;
    height: 100%;
    outline: none;
    padding-top: 0 !important;
    border-radius: 4px;
    border: none;
    font-size: 12px;
    text-indent: 1em;
  }

  .search-autocomplete {
    width: 100%;
    height: 40px;
    border-radius: 4px;
    background-color: #ffffff;

    ::v-deep {
      .el-input__suffix {
        right: 13px;
        .search-icon {
          padding-left: 5px;
          display: flex;
          height: 100%;
          align-items: center;
          cursor: pointer;
          .icon-search {
            display: block;
            width: 24px;
            height: 24px;
          }
        }
      }
      .el-input__inner {
        padding-top: 0px;
        color: #001b42;
        font-size: 12px;
        font-weight: 500;

      }
      .el-input-group__append {
        padding: 0;
        background-color: #ffffff;
        .append-box {
          padding: 0 10px;
          border-left: 1px solid #dee5ef;
          display: flex;
          align-items: center;
          justify-content: center;
          .append-icon {
            display: inline-block;
            width: 24px;
            height: 24px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            cursor: pointer;
          }
        }
      }
      .search-autocomplete-popper {
        position: absolute !important;
        width: auto !important;
        left: 0 !important;
        right: 0 !important;
        border: none;
        // box-shadow: 0 4px 6px 0 rgba(70, 83, 106, 0.2);
        .el-autocomplete-suggestion__wrap {
          padding: 12px 0 !important;
          border-radius: 6px;
          box-shadow: 0 1px 5px 0 rgba(0, 5, 57, 0.2) !important;
          .el-autocomplete-suggestion__list {
            padding: 0 10px;
            li {
              padding: 0;
              background: #fff !important;
              &:hover {
                border-radius: 4px;
                background: #f4f5f9 !important;
              }
              .clear-history-container {
                padding: 0px 16px 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: initial;
                line-height: normal;
                background: #ffffff !important;
                .title {
                  font-family: HelveticaNeue, sans-serif;
                  font-size: 12px;
                  color: #99a4b3;
                }
                .clear-btn {
                  font-family: HelveticaNeue, sans-serif;
                  font-size: 12px;
                  color: #4066d4;
                  cursor: pointer;
                }
              }
              .search-result-wrapper {
                width: 100%;
                padding: 0 10px;
                .search-result-container {
                  display: flex;
                  align-items: center;
                  overflow: hidden;
                  .search-result-icon {
                    margin-right: 8px;
                    flex-shrink: 0;
                    width: 20px;
                    height: 20px;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                  }
                  .address-icon {
                    background: url("../../../../../assets/img/search-list-icon/ic-list-address.svg")
                      no-repeat;
                  }
                  .poi-icon {
                    margin-right: 10px;
                    flex-shrink: 0;
                    font-size: 20px;
                  }
                  .search-result-content {
                    padding: 11px 0;
                    flex: 1;
                    overflow: hidden;
                    line-height: normal;
                    .title {
                      font-weight: 500;
                      font-size: 12px;
                      color: #001b42;
                      b {
                        font-family: HelveticaNeue-Medium, sans-serif;
                      }
                    }
                    .address {
                      margin-top: 4px;
                      font-family: HelveticaNeue, sans-serif;
                      font-size: 12px;
                      color: #7f8da0;
                    }
                  }
                }
              }
              &:nth-last-of-type(1) {
                .search-result-wrapper .search-result-container {
                  border: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .search-focus {
    transform: translateY(2px);
    font-size: 12px;
    background: #fff;
    margin-left: 15px;
    color: #4066d4;
    font-weight: 500;
  }
  .search-value-focus {
    transform: translateY(2px);
    font-size: 12px;
    background: #fff;
    margin-left: 15px;
    color: #7f8596;

    font-weight: 500;
  }
  .search-blur {
    font-size: 12px;
    transform: translateY(19px);
    color: #7f8596;
    font-weight: 500;
  }
  .connected {
    ::v-deep {
      .search-autocomplete-popper {
        margin-top: 4px !important;
        border: 0;
        // border-top: 1px solid #dee5ef;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
        .popper__arrow {
          display: none;
        }
      }
    }
    &[aria-expanded="true"] {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
/deep/.overflow-management {
  b {
    color: #4066d4 !important;
  }
}
</style>
